"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ApplicationModuleReducer = undefined;

var _apiApplicationModule_delete = require("../actions/esdb/apiApplicationModule_delete");

var _apiApplicationModule_post = require("../actions/esdb/apiApplicationModule_post");

var _apiApplicationModules = require("../actions/esdb/apiApplicationModules");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	loading: false,
	error: null,
	data: null
};
var ApplicationModuleReducer = exports.ApplicationModuleReducer = function ApplicationModuleReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _apiApplicationModule_delete.API_APPLICATION_MODULE_DELETE_REQUEST:
		case _apiApplicationModule_post.API_APPLICATION_MODULE_POST_REQUEST:
		case _apiApplicationModules.API_APPLICATION_MODULES_REQUEST:
			return Object.assign({}, state, action.payload);

		case _apiApplicationModule_delete.API_APPLICATION_MODULE_DELETE_SUCCESS:
			var newData = state.data.filter(function (entry) {
				return entry != action.payload.data.DELETED_APPLICATION_MODULE;
			});
			return Object.assign({}, state, {
				data: newData,
				loading: action.payload.loading,
				error: action.payload.error
			});

		case _apiApplicationModule_post.API_APPLICATION_MODULE_POST_SUCCESS:
		case _apiApplicationModules.API_APPLICATION_MODULES_SUCCESS:
			return _lodash2.default.merge({}, state, {
				data: action.payload.data.APPLICATION_MODULES,
				loading: action.payload.loading,
				error: action.payload.error
			});

		default:
			return state;
	}
};